<div class="alert alert-success" *ngIf="alertSuccess">
    Expense deleted successfully!
</div>
<div class="alert alert-danger" *ngIf="timeOutError">
    {{timeoutErrorMessage}}
</div>
<div class="fonts">
    <div class="row container-fluid overall-margin">
        <div class="col-md-12" [ngClass]="{'fontFamily-margin': true}">
            <div class="col-md-12 col-xs-12 col-sm-12 p-0 heading" style="display:inline-flex">
                <div class="col-9 p-0">
                <span class="span-create-edit-hoshin color">Budget Requests</span>
                <span *ngIf="(this.adminId==1 || this.adminId=='1' || this.adminId=='4' || this.adminId==4)" style="font-size: 13px;"><a href="assets/userguides/Budget_SuperAdmin.pdf" download class="pl-3 download-link">User Guide</a></span>
                <span *ngIf="!(this.adminId==1 || this.adminId=='1' || this.adminId=='4' || this.adminId==4)" style="font-size: 13px;"><a href="assets/userguides/Budget_ChapterAdmins.pdf" download class="pl-3 download-link">User Guide</a></span>   
            </div>
                <div class="col-3 text-right p-0">
                    <button type="button" class ="btn btn-danger btn-style" (click)="clearExpenseClaimData()"
                     routerLink="../expense-claim">NEW BUDGET REQUEST</button>
                </div>
            </div>

            <div class="mt-4 mb-3 ml-2 p-0 text-secondary information">
                <span><mat-icon class="info-icon color" style="font-size: 16px;
                    margin-left: 10px;">info</mat-icon></span>
                <span>Section to view Budget Requests.</span>
            </div>
        </div>
         <!-- search options -->
         <div id='included_page' class="form-outer-div col-12">
            <div class="form-group-div">
                <span>
                    <ng-select placeholder="--Select SITE--" class="custom" [items]="siteList" bindLabel="siteName"
                        bindValue="siteId" [(ngModel)]="siteId" (change)="siteChange($event)"></ng-select>
                </span>
            </div>
        
            <div class="form-group-div">
        
                <div>
                    <ng-select placeholder="--Select BPG--" class="custom" [items]="bpgList" bindLabel="bpgName"
                        bindValue="bpgId" [(ngModel)]="bpgId" (change)="bpgChange($event)"></ng-select>
                </div>
            </div>
        
            <div class="form-group-div">
                <ng-select placeholder="--Select Status--" class="custom" [items]="statusList" bindLabel="status"
                    bindValue="status" [(ngModel)]="status" (change)="changeStatus($event)"></ng-select>
            </div>

            <div class="form-group-div">
                <ng-select placeholder="--Select Fiscal Year--" class="custom" [items]="fyList" bindLabel="fySelected"
                    bindValue="fySelected" [(ngModel)]="fySelected" (change)="changeFYSelected($event)"></ng-select>
            </div>
        
        
            <div class="form-group-div">
                <input type="text" class="form-control keywords" autocomplete="off" id="search"
                    placeholder="Search by expense name" [(ngModel)]="searchKey">
            </div>
            <div id="searchSecn" style="margin-top: 7px;">
                <button type="button" class="btn btn-danger" (click)="searchExpense()">Search</button>
            </div>
        </div>
         <!-- table data -->
         <div class="col-md-12">
            <div class="mt-4">
                <p class="noDataFound text-center color" *ngIf="noDataFound"> No record found ! </p>
                <div id="tabledemo1" *ngIf="tableShow">
                    <div class="table-container">
                        <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}"
                            class="table table-striped" id="tabledemo">
                            <thead>
                                <tr class="tr-th">
                                    <th scope="col">Budget Request</th>
                                    <th scope="col">Chapter</th>
                                    <th scope="col">Last Submitted Date</th>
                                    <th scope="col">Last Submitted By</th>
                                    <th scope="col">Amount</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let data of expenseList  | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements }">
                                    <td scope="col" style="width: 15%;">{{data.expenseName}}</td>
                                    <td scope="col" style="width: 25%; white-space: nowrap;" class="color"><span class="chapter-border">{{data.siteName| ellipsis:15}} - {{data.bpgName | ellipsis:15}}</span></td>
                                    <td scope="col" style="width: 12%;">{{data.scheduledDate | date:'MM-dd-yyyy'}}</td>
                                    <td scope="col" style="width: 11%;">{{data.modifiedBy}}</td>
                                    <td scope="col" style="width: 7%;">{{data.totalExpense | currency:'USD'}}</td>
                                    <td scope="col" style="width: 7%;">{{data.expenseStatus}}</td>
                                    <td scope="col" style="width: 13%;">
                                      <a class="viewButton" title="View" *ngIf="(adminId==1||adminId==2||adminId==3 || adminId==4||isNaacAdmin||isbpgAdmin)"(click)="viewMoreExpenseDetails(data.expenseId,'VIEW')"><img src="assets/images/view.png" class="image" alt="Angular Logo"></a>     
                                      <a class="editButton" title="Edit" (click)="editExpense(data)" *ngIf="(adminId==1||adminId==2||adminId==3||adminId==4||isNaacAdmin || isbpgAdmin)&&(data.expenseStatus=='NEW'||data.expenseStatus=='SCHEDULED'|| data.expenseStatus=='REJECTED')" routerLink="../expense-claim"><img src="assets/images/edit.png" class="image" alt="Angular Logo"></a>
                                      <a class="deleteButton" title="Delete" (click)="deleteClick(data.expenseId,'DELETE')" data-toggle="modal" data-target="#myModal"*ngIf="(adminId==1||adminId==2||adminId==3 ||adminId==4||isNaacAdmin|| isbpgAdmin)&&(data.expenseStatus=='NEW'||data.expenseStatus=='SCHEDULED')"><img src="assets/images/delete.png" class="image" alt="Angular Logo"></a>
                                    </td>
                                  </tr>
                            </tbody>
                        </table>
                        <app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="1"></app-confirmation-modal> 
                    </div>
                    <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv mb-5">
                        <span>Showing {{currentShowingElements}} of {{numberOfElements}} results</span>
                        <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageChanged($event)"></pagination-controls>
                      </div>
                </div>
            </div>
         </div>
    </div>
</div>
